import React from "react";

const SoonFuture = () => {
  return (
    <h6 className=" alert alert-light shadow-sm mt-2 m-0 text-center border-rounded w-50 mx-auto">
      Coming soon...
    </h6>
  )
};

export default SoonFuture;
